import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';

export default {
  getDetail: state => state.detail,
  getJobDetail: state => state.jobDetail,

  getPageInfo: state => state.pageInfo,
  getLikePageInfo: state => state.likePageInfo,
  getPurchasePageInfo: state => state.purchasePageInfo,
  getCoordinateChange: state => state.coordinateChange,

  getRegister: state => state.register,
  getCategorySearchFlag: state => state.categorySearchFlag,
  getMarketingRegister: state => state.marketingRegister,
  getDonationRegister: state => state.donationRegister,
  getJobRegister: state => state.jobRegister,

  getCategoryList: state => state.categoryList,
  getSignboardFeedList: state => state.signboardFeedList,
  getSignboardDetail: state => state.signboardDetail,
  getSignboardChargeMode: state => {
    if (state.signboardChargeMode) return state.signboardChargeMode;
    // fallback: localStorage에서 복원 (페이지 이동/새로고침 대응)
    try {
      const v = localStorage.getItem('signboardChargeMode');
      return v ? Number(v) : null;
    } catch (e) { return null; }
  },
  getAddressList: state => state.addressList,
  getLikeList: state => state.likeList,
  getProductList: state => state.productList,
  getBusinessList: state => state.businessList,
  // 260429: 마이페이지 전용
  getMyBusinessList: state => state.myBusinessList,
  getMyPageInfo: state => state.myPageInfo,
  getMyCondition: state => state.myCondition,
  getBusinessSearchList: state => state.businessSearchList,
  getBusinessPreviewList: state => state.businessPreviewList,
  getPurchaseList: state => state.purchaseList,
  kakaoPageableCount: state => state.kakaoPageableCount,
  kakaoSearchText: state => state.kakaoSearchText,

  getCondition: state => state.condition,
  getAddressCondition: state => state.addressCondition,
  getPurchaseCondition: state => state.purchaseCondition,
  getLikeCondition: state => state.likeCondition,
  getSearchText: state => state.searchText,

  getRecentSearch: state => state.recentSearch,
  getCoordinate: state => state.coordinate,
  getIsLocationModal: state => state.isLocationModal,
  getSelectAddress: state => state.selectAddress,
  getAddressSearchText: state => state.addressSearchText,
  getMarkerPin: state => state.markerPin,
  getRegisterPin: state => state.registerPin,
  getMarketingTicketCount: state => state.marketingTicketCount,
  getFixCoordinate: state => state.fixCoordinate,
  getOverseasFilter: state => state.overseasFilter,
  // 260522: 검색 네이버 미가입 ghost 카드 (똑딱 모델)
  getGhostList: state => state.ghostList,
  // 260618: GPS 실위치 좌표 (유령기업 카카오 검색용)
  getGpsCoordinate: state => state.gpsCoordinate
};
